<template>
  <div class="modal-window">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.BoardHistory.001","활동내역") }}</div>
      <button @click="closeHistoryModal" class="btn_close">닫기</button> 
    </header>

    <div class="modal-content">
      <div class="tab_ty1 bds041" id="tabsTy1">
        <ul class="tab-menu">
          <li v-for="(tab, index) in tabsTy1" :class="{active:currentTab1===index}" :key="`tab` + index">
            <button type="button" v-on:click="changeBoardHistoryTab(index)">{{tab}}</button>
          </li>
        </ul>

        <div class="tab-content">
          <div v-show="currentTab1 == 0" class="blcok">
            <div class="top_info_txt">{{ $i18nUtil.trans("message.BoardHistory.001","블록별 최초 생성자 정보 및 마지막 수정자 정보를 확인할 수 있습니다.") }}</div>
            <div class="tb-list_ty2">
              <div class="tb-header clear">
                <div class="tb_sort fr">
                  <!-- <div class="dropdown ty1 right">
                    <v-menu bottom left :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">생성/수정자 전체</v-btn>
                      </template>
                      <div class="dropdown-list checkbox member-name">
                        <div class="scroll">
                          <div class="dropdown-list-item">
                            <input 
                              type="checkbox" 
                              name="" 
                              checked
                              v-model="allSelectedHistoryUser"
                              @change="selectAllHistoryUser"
                              id="chkHistoryUserIdAll"
                            />
                            <label for="chkHistoryUserIdAll">전체</label>
                          </div>
                          <div 
                            class="dropdown-list-item" 
                            v-for="(historyUserItem, historyUserIndex) in paperBlockHistoryUserList" 
                            :key="`historyUserItem`+historyUserIndex"
                          >
                              <input 
                                type="checkbox" 
                                :id="`bds`+historyUserIndex"
                                name="" 
                                v-model="historyUserIds"
                                :value="historyUserItem.modUserId"
                                @change="checkHistoryUserFilter"
                              />
                              <label :for="`bds`+historyUserIndex">{{historyUserItem.modUserName}}</label>
                          </div>
                        </div>
                      </div>
                    </v-menu>
                  </div> -->
                </div>
              </div>

              <div v-if="showFlag">
              <v-data-table
                :headers="blockHeaders"
                :items="paperBlockHistoryListFilter"
                item-key="name"
                :sort-by="['modDate']"
                :sort-desc="[true]"
                :must-sort="true"
                :page.sync="blockPage"
                :items-per-page="paperBlockHistoryListFilter == null ? 0 : paperBlockHistoryListFilter.length"
                @page-count="blockPageCount = $event"
                hide-default-footer
                class="tb-contents hover-none" v-if="blockFlag">
                <template v-slot:headers="props">{{props}}</template>
                <template v-slot:item="paperBlockHistoryItem">
                  <!-- 빈 블록의 경우 노출하지 않음 -->
                  <tr>
                    <td
                      v-if="
                        paperBlockHistoryItem.item.blockType != 'IMAGE' 
                        && paperBlockHistoryItem.item.blockType != 'TODO' 
                        && paperBlockHistoryItem.item.blockType != 'FILE' 
                        && paperBlockHistoryItem.item.blockType != 'LINK' 
                        && paperBlockHistoryItem.item.blockType != 'DECISION'
                      "
                    >
                      <div 
                        class="editor-wrapper" 
                        v-html="paperBlockHistoryItem.item.contentPath">
                      </div>
                    </td>
                    <!-- [이미지 블록] s -->
                    <td v-else-if="paperBlockHistoryItem.item.blockType == 'IMAGE'">
                      <div class="editor-wrapper" >
                        <div class="contentblock board_layout">
                          <div class="eidtbox-ty1" :class="paperBlockHistoryItem.item.toggleImage != 'Y' ? 'attachfile_box' : 'align_top'">
                            <div class="row_box clear hover_box">
                              <div class="hover_inner" :style="paperBlockHistoryItem.item.toggleImage != 'Y' ? 'width: 100%;' : ''">
                                <div class="file_row clear"
                                  :class="paperBlockHistoryItem.item.toggleImage == null ? '' : 'hidden'">
                                  <div class="file_name ell-singleline"
                                    :class="'ico-file-' + iconType(paperBlockHistoryItem.item)"
                                    @click="toggleImage(paperBlockHistoryItem.item, paperBlockHistoryItem.index, 'Y')">
                                    {{ paperBlockHistoryItem.item.contentPath == "" ? "image.jpg" : paperBlockHistoryItem.item.contentPath }}
                                  </div>
                                  <div class="btn">
                                    <button type="button"
                                      class="img_zoom permit_everyone"
                                      @click="toggleImage(paperBlockHistoryItem.item, paperBlockHistoryItem.index, 'Y')">
                                      이미지 확대 축소
                                    </button>
                                    <div class="droplayer icon more large right nosel">
                                      <v-menu bottom left>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn v-bind="attrs" v-on="on" disabled>더보기</v-btn>
                                        </template>
                                      </v-menu>
                                    </div>
                                  </div>
                                </div>
                                <div class="img_box" :class="paperBlockHistoryItem.item.toggleImage != null ? '' : 'hidden'">
                                  <div 
                                    class="one"
                                    :data-block-file-id="paperBlockHistoryItem.item.fileId"
                                    :data-block-id="paperBlockHistoryItem.item.paperBlockId"
                                  >
                                    <img class="preview hidden" src="image.jpg" alt="" v-if="paperBlockHistoryItem.item.loading" />
                                    <div v-else>
                                      <ProgressCircle :width="100" :height="100"></ProgressCircle>
                                    </div>
                                    <div class="btn">
                                      <button
                                        type="button"
                                        class="img_zoom active permit_everyone"
                                        @click="toggleImage(paperBlockHistoryItem.item, paperBlockHistoryItem.index, null)">
                                        이미지 축소 확대
                                      </button>
                                      <div class="droplayer icon more large right nosel">
                                        <v-menu bottom left>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" disabled>더보기</v-btn>
                                          </template>
                                        </v-menu>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!-- [이미지 블록] e -->
                    <!-- [할 일 블록] s -->
                    <td v-else-if="paperBlockHistoryItem.item.blockType == 'TODO'">
                      <div class="editor-wrapper" >
                        <div class="contentblock board_layout">
                          <div class="eidtbox-ty1 attachfile_box align_top">
                            <div
                              class="hover_box"
                              :class="
                                (paperBlockHistoryItem.item.todoMap.todoMain && paperBlockHistoryItem.item.todoMap.todoList[0].todoStatus != 'R'
                                  ? ' todo_wrap_view'
                                  : ' todo_wrap_write')
                              "
                            >
                              <div class="hover_inner">
                                <template
                                  v-if="paperBlockHistoryItem.item.todoMap && paperBlockHistoryItem.item.todoMap.todoMain && paperBlockHistoryItem.item.todoMap.todoList[0].chargerId == null"
                                >
                                  <div class="top">
                                    <div class="label-fin">{{$i18nUtil.trans("entity.todo","할 일")}}</div>
                                    <div class="dividing_line_ty2"></div>
                                    <div class="dropdown ty1">
                                      <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn v-bind="attrs" v-on="on" disabled>{{ $i18nUtil.trans("message.BoardHistory.009","담당자 선택") }}</v-btn>
                                        </template>
                                      </v-menu>
                                    </div>
                                    <div class="right">
                                      ~<div class="calendar_box">
                                        <datepicker
                                          format="yyyy.MM.dd"
                                          :placeholder="$i18nUtil.trans(message.placeholder.select.endDate)"
                                          v-model="paperBlockHistoryItem.item.todoMap.endDate"
                                          disabled
                                        ></datepicker>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="write_grp clear">
                                    <div class="write fl">
                                      <form action="">
                                        <div class="input-box">
                                          <textarea
                                            type="text"
                                            :placeholder="$i18nUtil.trans('message.BoardHistory.003','할 일을 입력해 주세요.')"
                                            disabled
                                            v-model="paperBlockHistoryItem.item.todoMap.todoTitle"
                                            class="modal_todo_wrap"
                                          ></textarea>
                                          <button type="reset" class="input-txt-del" disabled>입력 삭제</button>
                                        </div>
                                        <div class="input-box"></div>
                                      </form>
                                    </div>
                                    <div class="btn_box fr">
                                      <button type="button" class="btn-txt-primary" disabled >{{ $i18nUtil.trans("button.cancel","취소") }}</button>
                                      <button type="button" class="btn-txt-primary black" disabled>{{ $i18nUtil.trans("button.register","등록") }}</button>
                                    </div>
                                  </div>
                                </template>

                                <template
                                  v-else-if="paperBlockHistoryItem.item.todoMap &&
                                    paperBlockHistoryItem.item.todoMap.todoList &&
                                    paperBlockHistoryItem.item.todoMap.todoList[0] &&
                                    (paperBlockHistoryItem.item.todoMap.todoList[0].todoStatus == 'P' ||
                                      paperBlockHistoryItem.item.todoMap.todoList[0].todoStatus == 'C')
                                  "
                                >
                                  <div class="top">
                                    <div class="label-fin">{{$i18nUtil.trans("entity.todo","할 일")}}</div>
                                    <v-btn
                                      v-if="paperBlockHistoryItem.item.todoMap.todoList[0].todoStatus === 'C'"
                                      disabled
                                      ><span class="ico-complete"></span>{{ $i18nUtil.trans("entity.todo.status.completed","완료") }}</v-btn
                                    >
                                    <v-btn v-else disabled
                                      ><span class="ico-incomplete"></span>{{ $i18nUtil.trans("entity.todo.status.incomplete","미완료") }}</v-btn
                                    >
                                    <div class="right">
                                      <div
                                        class="date"
                                        v-if="paperBlockHistoryItem.item.todoMap.todoList[0].todoStatus === 'C'"
                                      >
                                        {{ $moment(paperBlockHistoryItem.item.todoMap.todoList[0].terDate).format('YYYY.MM.DD') }}
                                      </div>
                                      <div
                                        class="date"
                                        v-if="paperBlockHistoryItem.item.todoMap.todoList[0].todoStatus != 'C'"
                                      >
                                        ~{{ $moment(paperBlockHistoryItem.item.todoMap.endDate).format('YYYY.MM.DD') }}
                                      </div>
                                      <div class="re-de">
                                        <div class="re">
                                          <div class="droplayer relative">
                                            <v-menu offset-y>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on"
                                                  ><div
                                                    class="member"
                                                    :data-user-id="paperBlockHistoryItem.item.todoMap.todoMain.regUserId"
                                                  >
                                                    <img src="@/assets/img/no-avatar.png" alt="" />
                                                    {{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.todoMap.todoMain.regUserNameEn != null ? paperBlockHistoryItem.item.todoMap.todoMain.regUserNameEn : paperBlockHistoryItem.item.todoMap.todoMain.regUserName }}
                                                  </div>
                                                </v-btn>
                                              </template>
                                              <div class="dropdown-list">
                                                <UserTooltip
                                                  :userId="paperBlockHistoryItem.item.todoMap.todoMain.regUserId"
                                                />
                                              </div>
                                            </v-menu>
                                          </div>
                                        </div>
                                        <div class="division"></div>
                                        <div class="de">
                                          <div class="droplayer relative">
                                            <v-menu offset-y>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on"
                                                  ><div
                                                    class="member"
                                                    :data-user-id="paperBlockHistoryItem.item.todoMap.todoList[0].chargerId"
                                                  >
                                                    <img src="@/assets/img/no-avatar.png" alt="" />
                                                    {{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.todoMap.todoList[0].chargerNameEn != null ? paperBlockHistoryItem.item.todoMap.todoList[0].chargerNameEn : paperBlockHistoryItem.item.todoMap.todoList[0].chargerName }}
                                                  </div></v-btn
                                                >
                                              </template>
                                              <div class="dropdown-list">
                                                <UserTooltip 
                                                  :userId="paperBlockHistoryItem.item.todoMap.todoList[0].chargerId"
                                                />
                                              </div>
                                            </v-menu>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="droplayer icon more large right nosel">
                                        <v-menu bottom left>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" disabled>더보기</v-btn>
                                          </template>
                                        </v-menu>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="view multi-ellipsis"
                                    disabled
                                    v-html="paperBlockHistoryItem.item.todoMap.todoMain.todoTitle.split('\n').join('<br />')"
                                  ></div>
                                </template>

                                <template v-else-if="paperBlockHistoryItem.item.todoMap && modalInfo.userInfo.userId === paperBlockHistoryItem.item.regUserId">
                                  <div class="top">
                                    <div class="label-fin">{{$i18nUtil.trans("entity.todo","할 일")}}</div>
                                    <div class="dividing_line_ty2"></div>
                                    <div class="dropdown ty1">
                                      <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn v-bind="attrs" v-on="on" disabled>{{ $i18nUtil.trans("message.BoardHistory.009","담당자 선택") }}</v-btn>
                                        </template>
                                      </v-menu>
                                    </div>
                                    <div class="right">
                                      ~<div class="calendar_box">
                                        <datepicker
                                          format="yyyy.MM.dd"
                                          :placeholder="$i18nUtil.trans('message.placeholder.select.endDate','종료일 선택')"
                                          v-model="paperBlockHistoryItem.item.todoMap.endDate"
                                          disabled
                                        ></datepicker>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="write_grp clear">
                                    <div class="write fl">
                                      <form action="">
                                        <div class="input-box">
                                          <textarea
                                            type="text"
                                            :placeholder="$i18nUtil.trans('message.BoardHistory.003','할 일을 입력해 주세요.')"
                                            disabled
                                            v-model="paperBlockHistoryItem.item.todoMap.todoTitle"
                                            class="modal_todo_wrap"
                                          />
                                          <button type="reset" class="input-txt-del" disabled>입력 삭제</button>
                                        </div>
                                      </form>
                                    </div>
                                    <div class="btn_box fr">
                                      <button type="button" class="btn-txt-primary" disabled >{{ $i18nUtil.trans("button.cancel","취소") }}</button>
                                      <button type="button" class="btn-txt-primary black" disabled>{{ $i18nUtil.trans("button.register","등록") }}</button>
                                    </div>
                                  </div>
                                </template>
                                
                                <template
                                  v-else-if="
                                    paperBlockHistoryItem.item.todoMap.todoList == null && paperBlockHistoryItem.item.todoMap.todoMain == null && modalInfo.userInfo.userId != paperBlockHistoryItem.item.regUserId
                                  "
                                >
                                  <div class="top loading-box">
                                    <div class="label-fin">{{$i18nUtil.trans("entity.todo","할 일")}}</div>
                                    <div class="loader_wrap">
                                      <div class="loader">Loading...</div>
                                      <span>{{ $i18nUtil.trans("message.ContentBlockTypeTodo.008","보드멤버가 할 일을 작성중입니다.") }}</span>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!-- [할 일 블록] e -->
                    <!-- [의사결정 블록] s -->
                    <td v-else-if="paperBlockHistoryItem.item.blockType == 'DECISION'">
                      <div class="editor-wrapper" >
                        <div class="contentblock board_layout">
                          <div class="eidtbox-ty1 attachfile_box">
                            <div class="hover_box" :class="paperBlockHistoryItem.item.decision != null ? 'todo_wrap_view' : 'todo_wrap_write'">
                              <div class="hover_inner">
                                <template
                                  v-if="paperBlockHistoryItem.item.decision == null && modalInfo.userInfo.userId === paperBlockHistoryItem.item.regUserId"
                                >
                                  <div class="top">
                                    <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCssDecision' : '' ">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
                                    <span class="status-txt">{{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}</span>
                                    <div class="dividing_line_ty2"></div>
                                    <div class="dropdown ty1">
                                      <v-menu offset-y :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn v-bind="attrs" v-on="on" disabled>{{ $i18nUtil.trans("message.BoardHistory.010","결정자 선택") }}</v-btn>
                                        </template>
                                      </v-menu>
                                    </div>
                                    <div class="right">
                                      <div class="date">
                                        {{ $moment().format("YYYY.MM.DD") }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="write_grp clear">
                                    <div class="write fl">
                                      <form action="">
                                        <div class="input-box">
                                          <textarea
                                            type="text"
                                            required
                                            :placeholder="$i18nUtil.trans('message.BoardHistory.004','의사결정 요청 내용 등록 후, 내용을 클릭하면 파일을 첨부할 수 있습니다.')"
                                            disabled
                                            class="modal_todo_wrap"
                                          />
                                          <button type="reset" class="input-txt-del">입력 삭제</button>
                                        </div>
                                      </form>
                                    </div>
                                    <div class="btn_box fr">
                                      <button
                                        type="button"
                                        class="btn-txt-primary"
                                        disabled
                                      >
                                        {{ $i18nUtil.trans("button.cancel","취소") }}
                                      </button>
                                      <button
                                        type="button"
                                        class="btn-txt-primary black"
                                        disabled
                                      >
                                        {{ $i18nUtil.trans("button.register","등록") }}
                                      </button>
                                    </div>
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    paperBlockHistoryItem.item.decision == null && modalInfo.userInfo.userId != paperBlockHistoryItem.item.regUserId
                                  "
                                >
                                  <div class="top loading-box">
                                    <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCssDecision' : '' ">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
                                    <div class="loader_wrap">
                                      <div class="loader">Loading...</div>
                                      <span>{{ $i18nUtil.trans("message.ContentBlockTypeDecision.010","보드멤버가 의사결정을 작성중입니다.") }}</span>
                                    </div>
                                  </div>
                                </template>

                                <template v-else-if="paperBlockHistoryItem.item.decision != null">
                                  <div class="top">
                                    <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCssDecision' : '' ">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
                                    <span class="status-txt" v-if="paperBlockHistoryItem.item.decision.status == 'APPL'">{{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}</span>
                                    <span class="status-txt" v-if="paperBlockHistoryItem.item.decision.status == 'RETURN'">{{ $i18nUtil.trans("entity.decision.status.reject","반려") }}</span>
                                    <span class="status-txt" v-if="paperBlockHistoryItem.item.decision.status == 'APROVAL'">{{ $i18nUtil.trans("entity.decision.status.approval","승인") }}</span>
                                    <div class="dividing_line_ty2" v-if="paperBlockHistoryItem.item.decision.decisionFileCount > 0"></div>
                                    <div class="ico_attachfile" v-if="paperBlockHistoryItem.item.decision.decisionFileCount > 0">{{ $i18nUtil.trans("entity.file","첨부파일") }}</div>
                                    <div
                                      class="view multi-ellipsis"
                                      v-html="paperBlockHistoryItem.item.decision.contents.split('\n').join('<br />')"
                                    ></div>
                                    <div class="right">
                                      <div class="date" v-if="paperBlockHistoryItem.item.decision.status == 'APPL'">
                                        {{ $moment(paperBlockHistoryItem.item.decision.regDate).format("YYYY.MM.DD") }}
                                      </div>
                                      <div class="date" v-else>
                                        {{ $moment(paperBlockHistoryItem.item.decision.dediDate).format("YYYY.MM.DD") }}
                                      </div>
                                      <div class="re-de">
                                        <div class="re">
                                          <div class="droplayer relative">
                                            <v-menu offset-y>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on">
                                                  <div
                                                    class="member"
                                                    :data-user-id="paperBlockHistoryItem.item.decision.regUserId"
                                                    >
                                                    <img src="@/assets/img/no-avatar.png" alt="" />
                                                    {{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.decision.regUserNameEn != null ? paperBlockHistoryItem.item.decision.regUserNameEn : paperBlockHistoryItem.item.decision.regUserName }}
                                                  </div>
                                                </v-btn>
                                              </template>
                                              <div class="dropdown-list">
                                                <UserTooltip :userId="paperBlockHistoryItem.item.decision.regUserId" />
                                              </div>
                                            </v-menu>
                                          </div>
                                        </div>
                                        <div class="division"></div>
                                        <div class="de">
                                          <div class="droplayer relative">
                                            <v-menu offset-y>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on">
                                                  <div class="member" :data-user-id="paperBlockHistoryItem.item.decision.userId">
                                                    <img src="@/assets/img/no-avatar.png" alt="" />
                                                    {{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.decision.userName != null ? paperBlockHistoryItem.item.decision.userNameEn : paperBlockHistoryItem.item.decision.userName }}
                                                  </div>
                                                </v-btn>
                                              </template>
                                              <div class="dropdown-list">
                                                <UserTooltip :userId="paperBlockHistoryItem.item.decision.userId" />
                                              </div>
                                            </v-menu>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="droplayer icon more large right nosel"
                                        v-if="paperBlockHistoryItem.item.decision.regUserId == modalInfo.userInfo.userId"
                                      >
                                        <v-menu bottom left>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" disabled>더보기</v-btn>
                                          </template>
                                        </v-menu>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!-- [의사결정 블록] e -->
                    <!-- [파일 블록] s -->
                    <td v-else-if="paperBlockHistoryItem.item.blockType == 'FILE'">
                      <div class="editor-wrapper" >
                        <div class="contentblock board_layout">
                          <div class="eidtbox-ty1 attachfile_box">
                            <div class="row_box clear hover_box">
                              <div class="file_row clear">
                                <div class="file_name ico-file-pdf">
                                  <span>
                                    {{ paperBlockHistoryItem.item.contentPath }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!-- [파일 블록] e -->
                    <!-- [링크/관련보드 블록] s -->
                    <td v-else-if="paperBlockHistoryItem.item.blockType == 'LINK'">
                      <div class="editor-wrapper" >
                        <div class="contentblock board_layout">
                          <div class="eidtbox-ty1 align_top">
                            <div 
                              :class="paperBlockHistoryItem.item.linkMap.linkType == 'board' ? 'todo_wrap_view hover_box' : 'url_box hover_box tit-only'" 
                            >
                              <div class="hover_inner">
                                <!-- 관련보드 -->
                                <template v-if="paperBlockHistoryItem.item.linkMap && paperBlockHistoryItem.item.linkMap.linkType == 'board'">
                                  <div class="top">
                                    <div class="label-fin">
                                      <template v-if="paperBlockHistoryItem.item.linkMap.groupKbn == 'SHAR'">{{ $i18nUtil.trans("entity.paper.groupKbn.shar","정보 보드") }}</template>
                                      <template v-else-if="paperBlockHistoryItem.item.linkMap.groupKbn == 'CFRC'">{{ $i18nUtil.trans("entity.paper.groupKbn.cfrc","회의 보드") }}</template>
                                      <template v-else>{{ $i18nUtil.trans("entity.paper","보드") }}</template>
                                    </div>
                                    <span class="team">{{paperBlockHistoryItem.item.linkMap.subName}}</span>
                                    <div class="right">
                                      <div class="re-de">
                                        <div class="de">
                                          <div class="droplayer relative">
                                            <v-menu offset-y>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on">
                                                  <div class="member" :data-user-id="paperBlockHistoryItem.item.regUserId">
                                                    <img 
                                                      src="@/assets/img/no-avatar.png"
                                                      alt=""/>
                                                    {{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.regUserNameEn != null ? paperBlockHistoryItem.item.regUserNameEn : paperBlockHistoryItem.item.regUserName }}
                                                  </div>
                                                </v-btn>
                                              </template>
                                              <div class="dropdown-list">
                                                <UserTooltip :userId="paperBlockHistoryItem.item.regUserId"/>
                                              </div>
                                            </v-menu>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="droplayer icon more large right nosel">
                                        <v-menu bottom left>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" disabled>더보기</v-btn>
                                          </template>
                                        </v-menu>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="view"> 
                                    <a href="#">{{paperBlockHistoryItem.item.linkMap.title}}</a>
                                  </div>
                                </template>
                                <!-- 링크 타입이 일반 URL -->
                                <template v-if="paperBlockHistoryItem.item.linkMap && paperBlockHistoryItem.item.linkMap.linkType != 'board'">
                                  <div
                                    class="img"
                                    v-if="paperBlockHistoryItem.item.linkMap && modalTestHanwha(paperBlockHistoryItem.item.linkMap.link)">
                                    <img src="@/assets/img/board_url01.png" alt="" />
                                  </div>
                                  <div
                                    class="img"
                                    v-else-if="paperBlockHistoryItem.item.linkMap && paperBlockHistoryItem.item.linkMap.image">
                                    <img :src="paperBlockHistoryItem.item.linkMap.image" alt="" />
                                  </div>
                                  <div
                                    class="img"
                                    v-else>
                                    <img src="@/assets/img/board_url02.png" alt="" />
                                  </div>
                                  <div class="tit"
                                    v-if="paperBlockHistoryItem.item.linkMap && paperBlockHistoryItem.item.linkMap.title">
                                    &nbsp;
                                    <span v-if="paperBlockHistoryItem.item.linkMap.linkType === 'file'"></span>
                                    <span v-if="paperBlockHistoryItem.item.linkMap.linkType === 'google'">{{ $i18nUtil.trans("message.BoardHistory.011","[구글드라이브]") }}</span>
                                    {{ paperBlockHistoryItem.item.linkMap.title }}
                                  </div>
                                  <div class="tit"
                                    v-else-if="paperBlockHistoryItem.item.linkMap">
                                    &nbsp;
                                    {{ paperBlockHistoryItem.item.linkMap.link }}
                                  </div>

                                  <div class="droplayer icon more large right nosel">
                                    <v-menu bottom left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" disabled>더보기</v-btn>
                                        </template>
                                    </v-menu>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!-- 생성일 정보 -->
                    <td class="txtc" style="width: 150px" >
                      {{$moment(paperBlockHistoryItem.item.regDate).format("YYYY.MM.DD HH:mm:ss")}} 
                    </td>
                    <!-- 생성자 정보 -->
                    <td class="txtc" style="width: 111px">
                      <div class="droplayer member relative">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on"><b>{{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.regUserNameEn != null ? paperBlockHistoryItem.item.regUserNameEn : paperBlockHistoryItem.item.regUserName }}</b></v-btn>
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip
                              :userId="paperBlockHistoryItem.item.regUserId"
                            />
                          </div>
                        </v-menu>
                      </div>
                    </td>
                    <!-- 마지막 업데이트 정보 -->
                    <td class="txtc" style="width: 150px">
                      {{$moment(paperBlockHistoryItem.item.modDate).format("YYYY.MM.DD HH:mm:ss")}}
                    </td>
                    <!-- 생성/수정자 정보 -->
                    <td class="txtc" style="width: 111px">
                      <div class="droplayer member relative">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on"><b>{{ $i18nUtil.getLanguage() !== 'ko' && paperBlockHistoryItem.item.modUserNameEn != null ? paperBlockHistoryItem.item.modUserNameEn : paperBlockHistoryItem.item.modUserName }}</b></v-btn>
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip
                              :userId="paperBlockHistoryItem.item.modUserId"
                            />
                          </div>
                        </v-menu>
                      </div>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <div class="nodata-txt-noicon">
                    <v-alert :value="true">
                      {{ $i18nUtil.trans("message.BoardHistory.008","활동 내역이 없습니다.") }}
                    </v-alert>
                  </div>
                </template>
              </v-data-table>
              </div>
            </div>
          </div>

          <div v-show="currentTab1 == 1" class="bds_043">
            <div class="top_info_txt">{{ $i18nUtil.trans("message.BoardHistory.006","일자별로 업데이트 정보를 확인할 수 있습니다.(마지막 업데이트로부터 30일)") }}</div>
            <div class="tb-list_ty2">
              <div class="tb-header clear">
                <div class="txt fl">* {{ $i18nUtil.trans("message.BoardHistory.007","텍스트 본문 수정내역과 의견/답변은 활동내역으로 제공하지 않으며, 파일은 마지막 업데이트 정보만 확인할 수 있습니다.") }}</div>
                <div class="tb_sort fr">
                  <div class="calendar_box_grp">
                    <div class="calendar_box">
                        <!-- :endDate="new Date(searchEndDay||disabledEndDay)" -->
                        <!-- @closed="changeDate('searchStartDay')" -->
                      <datepicker 
                        format="yyyy.MM.dd" 
                        name="start" 
                        v-model="searchStartDay" 
                        :disabled-dates="{
                          ranges:[
                              {from: new Date('1900-01-01'), to: new Date(disabledStartDay)}
                            , {from: new Date(disabledEndDay), to: new Date('9999-12-31')}
                          ],
                        }"></datepicker>
                            <!-- , {from: new Date(searchEndDay), to: $moment(disabledEndDay).clone().add(1, 'days')} -->
                    </div>
                    <span>~</span>
                    <div class="calendar_box">
                        <!-- :startDate="new Date(searchStartDay||disabledStartDay)" -->
                        <!-- @closed="changeDate('searchEndDay')" -->
                      <datepicker 
                        format="yyyy.MM.dd" 
                        name="finish" 
                        v-model="searchEndDay" 
                        :disabled-dates="{
                          ranges:[
                              {from: new Date('1900-01-01'), to: new Date(disabledStartDay)}
                            , {from: new Date(disabledEndDay), to: new Date('9999-12-31')}
                          ]
                        }"></datepicker>
                            <!-- , {from: $moment(disabledStartDay).clone().subtract(1, 'days'), to: new Date(searchStartDay)} -->
                    </div>
                  </div>
                  <!-- <div class="dividing_line_ty2"></div>
                  <div class="droplayer icon filter-box board-list-e relative">
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="sel">필터</v-btn>
                      </template>
                      <div class="dropdown-list cnt board">
                        <div class="cnt_inner clear">
                          <div class="cnt-editor">
                            <div class="tit">구분</div>
                              <ul>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sall"
                                    checked
                                    v-model="allSelectedDayWorkKbn"
                                    @click="selectAllDayWorkItem"
                                  />
                                  <label for="sall">전체</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds1"
                                    v-model="dayWorkKbnIds"
                                    value="TODO"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds1">{{$i18nUtil.trans("entity.todo","할 일")}}</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds2"
                                    v-model="dayWorkKbnIds"
                                    value="FILE"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds2">파일</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds3"
                                    v-model="dayWorkKbnIds"
                                    value="IMAGE"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds3">이미지</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds4"
                                    v-model="dayWorkKbnIds"
                                    value="REL_PAPER"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds4">관련보드</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds5"
                                    v-model="dayWorkKbnIds"
                                    value="LINK"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds5">보드URL</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds6"
                                    v-model="dayWorkKbnIds"
                                    value="MENTION"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds6">호출</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds7"
                                    v-model="dayWorkKbnIds"
                                    value="TABLE"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds7">표</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds8"
                                    v-model="dayWorkKbnIds"
                                    value="DECI"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds8">의사결정</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds9"
                                    v-model="dayWorkKbnIds"
                                    value="MEMBER"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds9">멤버</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds10"
                                    v-model="dayWorkKbnIds"
                                    value="OUTPUT"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds10">최종결과물</label>
                                </li>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    id="sbds11"
                                    v-model="dayWorkKbnIds"
                                    value="PAPER"
                                    @change="checkDayWorkItemFilter"
                                  />
                                  <label for="sbds11">보드</label>
                                </li>
                              </ul>
                            </div>
                            <div class="cnt-editor">
                              <div class="tit">생성/수정자</div>
                              <ul>
                                <li>
                                  <input 
                                    type="checkbox" 
                                    name="" 
                                    checked
                                    v-model="allSelectedDayHistoryUser"
                                    @change="selectAllDayHistoryUser"
                                    id="chkDayHistoryUserIdAll"
                                  >
                                  <label for="chkDayHistoryUserIdAll">전체</label>
                                </li>
                                <li 
                                  v-for="(dayHistoryUserItem, dayHistoryUserIndex) in dayPaperHistoryUserList" 
                                  :key="`dayHistoryUserItem`+dayHistoryUserIndex"
                                >
                                  <input 
                                    type="checkbox" 
                                    :id="`dayBds`+dayHistoryUserIndex"
                                    name="" 
                                    v-model="dayHistoryUserIds"
                                    :value="dayHistoryUserItem.lastUpdUserId"
                                    @change="checkDayHistoryUserFilter"
                                  >
                                    <label :for="`dayBds`+dayHistoryUserIndex">{{dayHistoryUserItem.lastUpdUserName}}</label>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="info">필터는 중복 선택이 가능합니다.</div>
                        </div>
                      </v-menu>
                    </div>
                  </div> -->
                </div>
              </div>
              
              <v-data-table
                :headers="headers"
                :items="dayPaperHistoryListFilter"
                :must-sort="true"
                item-key="name"
                :sort-by.sync="daySortBy"
                :sort-desc.sync="daySortDesc"
                :page.sync="dayPage"
                :server-items-length="dayTotalElements"
                hide-default-footer
                class="tb-contents" v-if="flag">
                  <template v-slot:item="{ item }">
                    <tr :class="item.classState">
                      <td class="txtc" v-if="isToday(item.historyDate)"><momentAgo prefix="" suffix="전" :date="item.historyDate" lang="kr"></momentAgo></td>
                      <td class="txtc" v-else>{{ $moment(item.historyDate).format('YYYY.MM.DD') }}</td>
                      <td class="txtc">
                        {{ getWorkKbnName(item) }}
                      </td>
                      <td class="txtc">
                        {{ getWorkItemName(item.workItem, item.workKbn) }}
                      </td>
                      <td class="subject">
                        <div class="txt ell-singleline d-block" v-if="item.workKbn != 'LINK'">{{getHistoryContent(item)}}</div>
                        <div class="txt ell-singleline d-block" v-else>
                          {{item.linkMap.title}}
                          <span v-if="item.classState != 'del'">{{item.linkMap.link}}</span>
                          <span v-else>{{item.linkMap.link}}</span>
                          {{item.linkMap.description}}
                        </div>
                        <div class="reason"></div>
                        <div class="re-de" :class="(item.workKbn == 'DECI' || item.workKbn == 'TODO') ? '' : 'hide'">
                          <div class="re">{{ $i18nUtil.getLanguage() !== 'ko' && (item.workKbn == 'DECI' || item.workKbn == 'TODO') ? item.regUserNameEn : item.attr2 }}</div>
                          <div class="division"></div>
                          <div class="de">{{ item.workKbn == 'DECI' ? item.attr3 : item.attr4 }}</div>
                        </div>
                        <!-- <div class="re-de" :class="item.hide">
                          <div class="re">{{ item.re }}</div>
                          <div class="division"></div>
                          <div class="de">{{ item.de }}</div>
                        </div> -->
                      </td>
                      <td class="txtc">
                        <div class="droplayer member relative">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" class="name">{{ (item.workKbn == "MEMBER" && item.workItem == "LEAVE" && item.regUserId == item.attr2) ? $i18nUtil.trans("entity.user.me", "본인") : $i18nUtil.getLanguage() !== 'ko' && item.lastUpdUserNameEn != null ? item.lastUpdUserNameEn : item.lastUpdUserName }}</v-btn>
                            </template>
                            <div class="dropdown-list">
                              <UserTooltip
                                :userId="item.regUserId"
                              />
                            </div>
                          </v-menu>
                        </div>
                      </td>
                    </tr>
                </template>
                <template slot="no-data">
                  <div class="nodata-txt-noicon">
                    <v-alert :value="true">
                      {{ $i18nUtil.trans("message.BoardHistory.008","활동 내역이 없습니다.") }}
                    </v-alert>
                    <!-- <button type="button" class="btn-primary-small black" @click="addBoard(null)">업무보드추가</button> -->
                  </div>
                </template>
              </v-data-table>
              <div class="btn_box" v-if="dayTotalElements > dayPaperHistoryListFilter.length">
                <button type="button" class="btn-more-ico_small1 down" @click="moreView()">{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: dayTotalElements - dayPaperHistoryListFilter.length > 20 ? '20' : dayTotalElements - dayPaperHistoryListFilter.length}) }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Datepicker from "vuejs-datepicker";
import axios from "axios";
import Paging from "@/assets/css/board.css";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import ProgressCircle from "../../extensions/ProgressCircle";
import { mapActions } from "vuex";
// import { Editor } from "tiptap";
let HANWHA_DOMAINS = [
  "hanwha.com",
  "hanwha.co.kr",
  "hanwhalife.com",
  "hanwhain.com",
];
export default {
  components: {
    Datepicker,
    UserTooltip,
    ProgressCircle,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    /* tenantId */
    let tenantId = localStorage.getItem("tenantId");
    return {
      show: false,
      showFlag: true,
      hide: true,
      flag: true,
      blockFlag: true,
      currentTab1: 0,
      tenantId: tenantId,
      tabsTy1: tenantId != 203 ? [this.$i18nUtil.trans("title.BoardHistory.tab1.001","블록별"), this.$i18nUtil.trans("title.BoardHistory.tab1.002","일자별")]
                              : [this.$i18nUtil.trans("title.BoardHistory.tab1.001","블록별")], 
      blockHeaders: [
        { text: this.$i18nUtil.trans("entity.paper.filter.block","블록"), sortable: false, value: "contentPath" },
        {
          text: this.$i18nUtil.trans("message.ShareInfoManageDetail.007","생성일"),
          width: 150,
          sortable: true,
          value: "regDate",
        },
        {
          text: this.$i18nUtil.trans("message.ShareInfoManageDetail.006","생성자"),
          width: 111,
          sortable: false,
          value: "regUserName",
        },
        {
          text: this.$i18nUtil.trans("entity.paper.filter.lastUpdate_2","최종 수정"),
          width: 150,
          sortable: true,
          value: "modDate",
        },
        {
          text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUser","최종수정자"),
          width: 111,
          sortable: false,
          value: "modUserName",
        },
      ],
      headers: [
        { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdate","마지막 업데이트"), sortable: true, value: 'historyDate' },
        // { text: "마지막 업데이트", sortable: false, value: "historyDate" },
        { text: this.$i18nUtil.trans("entity.paper.filter.division","구분"), sortable: false, value: "workKbnName" },
        { text: this.$i18nUtil.trans("entity.paper.filter.item","항목"), sortable: false, value: "workItemName" },
        { text: this.$i18nUtil.trans("entity.paper.filter.contents","내용"), sortable: false, value: "contents" },
        { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUserName","생성/수정자"), sortable: true, value: 'lastUpdUserName' },
        // { text: "생성/수정자", sortable: false, value: "lastUpdUserName" },
      ],
      paperBlockHistoryList: [],
      paperBlockHistoryListFilter: [],
      paperBlockHistoryUserList: [],
      allSelectedHistoryUser: true,
      historyUserIds: [],
      searchStartDay: "",
      searchEndDay: "",
      disabledStartDay: "",
      disabledEndDay: "",
      dayPaperHistoryList: [],
      dayPaperHistoryListFilter: [],
      dayPaperHistoryUserList: [],
      allSelectedDayHistoryUser: true,
      dayWorkKbnList: [
        { workItem: "TODO", workItemName: this.$i18nUtil.trans("entity.todo","할 일") },
        { workItem: "FILE", workItemName: this.$i18nUtil.trans("entity.paper.workItem.file","파일") },
        { workItem: "IMAGE", workItemName: this.$i18nUtil.trans("entity.paper.workItem.image","이미지") },
        { workItem: "REL_PAPER", workItemName: this.$i18nUtil.trans("entity.paper.workItem.relatedBoard","관련보드") },
        { workItem: "LINK", workItemName: this.$i18nUtil.trans("entity.paper.workItem.boardUrl","보드URL") },
        { workItem: "MENTION", workItemName: this.$i18nUtil.trans("entity.paper.workItem.call") },
        { workItem: "TABLE", workItemName: this.$i18nUtil.trans("entity.paper.workItem.table","표") },
        { workItem: "DECI", workItemName: this.$i18nUtil.trans("entity.decision","의사결정") },
        { workItem: "MEMBER", workItemName: this.$i18nUtil.trans("entity.paper.workItem.member","멤버") },
        { workItem: "OUTPUT", workItemName: this.$i18nUtil.trans("entity.file.output","최종결과물") },
        { workItem: "PAPER", workItemName: this.$i18nUtil.trans("entity.paper","보드") },
      ],
      dayHistoryUserIds: [],
      allSelectedDayWorkKbn: true,
      dayWorkKbnIds: [
        "TODO",
        "FILE",
        "IMAGE",
        "REL_PAPER",
        "LINK",
        "MENTION",
        "TABLE",
        "DECI",
        "MEMBER",
        "OUTPUT",
        "PAPER",
      ],
      totalCount: 0, // 전체 활동내역 건수
      prevTotalCount: 0,
      viewCount: 20,
      currentCount: 0, // 현재 노출된 활동내역 건수
      moreViewCount: 20, // 더보기 활동내역 건수
      editor: null,
      pageCount: 0,
      blockPage: 1,
      dayPage: 0,
      // blockPageCount: 0,
      /* 정렬 */
      dayTotalElements: 0,
      daySortBy: ['historyDate'],
      daySortDesc: [true],
      /* 페이지 변경 또는 정렬 이벤트시 */
      dayChangeTableData: false,
      isDayInitFlag: false,
    };
  },
  methods: {
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    
    getPaperBlockHistoryList(isInitFlag) {
      let url = "/api/copaper/history/getPaperBlockHistoryList";
      let param = {
        paperId: this.$props.modalInfo.paperInfo.paperId,
      };
      let obj = this;
      obj.showLoadingbar();
      axios
        .post(url, param)
        .then((res) => {
          obj.hideLoadingbar();
          if (res.errorCode) {
            alert(res.errorCode);
          }
          let myUpdUserObj = {};
          let theOtherUpdUserObj = [];
          obj.paperBlockHistoryList = res.data.result;
          obj.historyUserIds = [];
          obj.paperBlockHistoryUserList = [];
          if (
            obj.paperBlockHistoryList != null &&
            obj.paperBlockHistoryList.length > 0
          ) {
            this.boardUtil = this.modalInfo.boardUtil;

            let deleteBlockList = [];

            res.data.result.forEach((element, index) => {
              // 빈블럭|구분선블럭 인덱스 저장.
              if((element.blockType == 'CONTENT' && obj.removeTag(element.contentPath) == '')
                  || (element.blockType == 'LINE')
                  || (element.blockType == 'IMAGELINK') ) {
                deleteBlockList.push(index);
                return;
              }

              if (element.modUserId == obj.$props.modalInfo.userInfo.userId) {
                myUpdUserObj = {
                  modUserId: element.modUserId,
                  modUserName: element.modUserName + "(" + obj.$i18nUtil.trans("entity.user.me","본인") + ")",
                };
              } else {
                let isCheck = false;
                theOtherUpdUserObj.forEach((userElem, userIndex) => {
                  if (userElem.modUserId == element.modUserId) {
                    isCheck = true;
                  }
                });
                if (!isCheck) {
                  theOtherUpdUserObj.push({
                    modUserId: element.modUserId,
                    modUserName: element.modUserName,
                  });
                  obj.historyUserIds.push(element.modUserId);
                }
              }
              if (element.blockType == "TABLE") {
                let html = obj.resizeBoardBlockTable(element.contentPath);
                element.contentPath = html;
              } else if (element.blockType == "IMAGE") {
                element.loading = false;
                // element.toggleImage = "Y";
              } else if (element.blockType == "TODO") {
              }
            });

            // 빈블럭 or 구분선블럭 제거
            deleteBlockList.sort(function(a,b){return b-a});
            deleteBlockList.forEach((data)=>{
              obj.paperBlockHistoryList.splice(data,1);
            })

            if (theOtherUpdUserObj.length != 0) {
              obj.paperBlockHistoryUserList = [...theOtherUpdUserObj];
            }

            // 이름순으로 정렬
            let sortingUpdUserList = obj.paperBlockHistoryUserList.sort(
              (prevObj, newObj) => {
                var prevModUserName = prevObj.modUserName;
                var newModUserName = newObj.modUserName;
                if (prevModUserName < newModUserName) {
                  return -1;
                }
                if (prevModUserName > newModUserName) {
                  return 1;
                }
                // 같을 경우
                return 0;
              }
            );
            obj.paperBlockHistoryUserList = sortingUpdUserList;

            if (myUpdUserObj != null && myUpdUserObj.modUserId != null) {
              obj.paperBlockHistoryUserList.splice(0, 0, myUpdUserObj);
              obj.historyUserIds.push(myUpdUserObj.modUserId);
            }
          }
          obj.setPaperBlockHistoryFilter();
          // if(isInitFlag != null && isInitFlag == true) {
          //   obj.getDayPaperHistoryList();
          // }
          // console.log('paperBlockHistoryUserList : ',obj.paperBlockHistoryUserList);
        })
        .catch((err) => {
          obj.hideLoadingbar();
          console.log("axios err => ", err);
        });
    },
    /* 블럭별 - 생성/수정자 필터 전체 */
    selectAllHistoryUser() {
      let obj = this;
      obj.historyUserIds = [];
      if (obj.allSelectedHistoryUser) {
        for (const user in obj.paperBlockHistoryUserList) {
          obj.historyUserIds.push(
            obj.paperBlockHistoryUserList[user].modUserId
          );
        }
      } else {
        obj.historyUserIds = [];
      }
      obj.setPaperBlockHistoryFilter();
    },
    /* 블럭별 - 생성/수정자 필터 */
    checkHistoryUserFilter(e) {
      let obj = this;
      if (obj.historyUserIds.length == obj.paperBlockHistoryUserList.length) {
        obj.allSelectedHistoryUser = true;
      } else {
        obj.allSelectedHistoryUser = false;
      }
      obj.setPaperBlockHistoryFilter();
    },
    /* 블럭별 리스트 필터링 */
    setPaperBlockHistoryFilter() {
      let obj = this;
      // 생성/수정자 필터링
      if (obj.historyUserIds.length > 0) {
        const result = $.map(obj.paperBlockHistoryList, function (val, key) {
          if (obj.historyUserIds.includes(String(val.modUserId))) return val;
        });
        obj.paperBlockHistoryListFilter = result;
      } else {
        obj.paperBlockHistoryListFilter = [];
      }

      // image load
      setTimeout(function () {
        obj.loadImages();
      }, 500);
      setTimeout(function () {
        obj.getUserPhotos();
      }, 500);
    },
    getDayPaperHistoryList() {
      let url = "/api/copaper/history/getDayPaperHistoryList";
      let param = {
        paperId: this.$props.modalInfo.paperInfo.paperId,
        sortKey: this.daySortBy[0],
        sortDesc: this.daySortDesc[0],
        page: this.dayPage,
        limitRow: "20",
        searchStartDay: this.searchStartDay,
        searchEndDay: this.searchEndDay,
      };
      let obj = this;
      obj.showLoadingbar();
      axios
        .post(url, param)
        .then((res) => {
          obj.hideLoadingbar();
          if(res.data.result.startDay) {
            obj.isDayInitFlag = false;
            obj.searchStartDay = res.data.result.startDay;
            obj.searchEndDay = res.data.result.endDay;
            obj.disabledStartDay = res.data.result.startDay;
            obj.disabledEndDay = res.data.result.endDay;
            obj.isDayInitFlag = true;
          }
          let list = res.data.result.dayPaperHistoryList.content;

          if(obj.$i18nUtil.getLanguage() === 'en' && obj.currentTab1 == 1) {
            list.forEach(item => {
              if(item.workKbn == 'DECI') {
                obj.getDecisionTargetEnName(item.objId).then((deciEn) => {
                  let nameEn = deciEn;
                  item.attr3 = nameEn != null ? nameEn : item.attr3;
                })
              }else { // item.workKbn == 'TODO'
                obj.getTodo(item.objId).then((todoEn) => {
                  let nameEn = todoEn
                  item.attr4 = nameEn != null ? nameEn : item.attr4;
                });
              }
            })
          }

          if(obj.dayPaperHistoryListFilter && obj.dayPage == 0) {
            
            obj.dayPaperHistoryListFilter = list;
          } 
          if(obj.dayPage > 0) {
            
            obj.dayPaperHistoryListFilter = obj.dayPaperHistoryListFilter.concat(list);
          }
          obj.dayTotalElements = res.data.result.dayPaperHistoryList.totalElements;
          // obj.dayHistoryUserIds = [];
          // obj.dayPaperHistoryUserList = [];
          obj.getFilterList();
        })
        .catch((err) => {
          obj.hideLoadingbar();
          console.log("axios err => ", err);
        });
    },
    loadImages() {
      let obj = this;
      let list = obj.$el.querySelectorAll(".img_box .one");
      let blockIdArr = [];
      let axiosImgElemArr = [];
      let axiosArr = [];
      let paperInfo = this.$props.modalInfo.paperInfo;
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let fileId = elem.getAttribute("data-block-file-id");
          let blockId = elem.getAttribute("data-block-id");
          let img = elem.querySelector("img");
          if (img != null) {
            let hiddenFlag = img.classList.contains("hidden");
            if (hiddenFlag) {
              axiosImgElemArr.push(img);
              let imageURI =
                "/api/cofile/paper/imageViewer?groupId=" +
                paperInfo.groupId +
                "&paperId=" +
                paperInfo.paperId +
                "&fileId=" +
                fileId;
              axiosArr.push(axios.get(imageURI, { responseType: "blob" }));
              blockIdArr.push(blockId);
            }
          }

          // obj.loadImage(img, fileId);
        }
      }
      if (axiosArr.length > 0) {
        axios
          .all(axiosArr)
          .then(
            axios.spread((...responses) => {
              if (responses.length > 0) {
                responses.forEach((_res, indx) => {
                  if (_res && _res.status == 200) {
                    axiosImgElemArr[indx].src = URL.createObjectURL(_res.data);
                    if (axiosImgElemArr[indx].classList.contains("hidden")) {
                      axiosImgElemArr[indx].classList.toggle("hidden");
                      blockIdArr[indx].loading = true;
                    }
                  } else {
                    axiosImgElemArr[indx].src = "image.jpg";
                  }
                });
              }
            })
          )
          .catch((errors) => {});
      }
    },
    getUserPhotos() {
      let obj = this;
      let list = obj.$el.querySelectorAll("div.member[data-user-id]");
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let fileId = elem.getAttribute("data-user-id");
          let img = elem.querySelector("img");
          if (img != null) {
            obj.HW_GET_USER_PHOTO({userId: fileId, img});
          }
        }
      }
    },
    /* 일자별 - 구분 필터 전체 */
    selectAllDayWorkItem() {
      let obj = this;
      obj.dayWorkKbnIds = [];
      if (!obj.allSelectedDayWorkKbn) {
        for (const kbn in obj.dayWorkKbnList) {
          obj.dayWorkKbnIds.push(obj.dayWorkKbnList[kbn].workItem);
        }
      }
      obj.getFilterList();
    },
    /* 일자별 - 구분 필터 */
    checkDayWorkItemFilter(e) {
      let obj = this;
      if (obj.dayWorkKbnIds.length == obj.dayWorkKbnList.length) {
        obj.allSelectedDayWorkKbn = true;
      } else {
        obj.allSelectedDayWorkKbn = false;
      }
      obj.getFilterList();
    },
    /* 일자별 - 생성/수정자 필터 전체 */
    selectAllDayHistoryUser() {
      let obj = this;
      obj.dayHistoryUserIds = [];
      if (obj.allSelectedDayHistoryUser) {
        for (const user in obj.dayPaperHistoryUserList) {
          obj.dayHistoryUserIds.push(
            obj.dayPaperHistoryUserList[user].lastUpdUserId
          );
        }
      } else {
        obj.dayHistoryUserIds = [];
      }
      obj.getFilterList();
    },
    /* 일자별 - 생성/수정자 필터 */
    checkDayHistoryUserFilter(e) {
      let obj = this;
      if (obj.dayHistoryUserIds.length == obj.dayPaperHistoryUserList.length) {
        obj.allSelectedDayHistoryUser = true;
      } else {
        obj.allSelectedDayHistoryUser = false;
      }
      obj.getFilterList();
    },
    getFilterList() {
      let obj = this;
      obj.showLoadingbar();
      if (
        obj.dayPaperHistoryListFilter != null &&
        obj.dayPaperHistoryListFilter.length > 0
      ) {
        obj.dayPaperHistoryListFilter.forEach((dayItem) => {
          obj.getHistoryContent(dayItem);
        });
      }

      obj.flag = false;
      obj.flag = true;
      obj.hideLoadingbar();
    },
    /* 더보기 클릭 */
    moreView() {
      let obj = this;
      obj.dayPage = obj.dayPage + 1;
      obj.getDayPaperHistoryList();
    },
    /* 오늘 날짜 체크 */
    isToday(date) {
      let obj = this;
      let now = obj.$moment();
      let before24hours = obj.$moment().subtract(1, "days");
      let lastUpdatedTime = obj.$moment(date);

      if (lastUpdatedTime.isBetween(before24hours, now)) {
        // 24시간 이내
        return true;
      } else {
        // 24시간 이후
        return false;
      }
    },
    getWorkKbnName(workKbnCode) {
      let workKbnName = "";
      switch (workKbnCode.workKbn) {
        case "TODO":
          workKbnName = this.$i18nUtil.trans("entity.todo","할 일");
          break;
        case "PERIOD":
        case "PAPER":
        case "TITLE":
          workKbnName = workKbnCode.groupName === "정보공유" ? this.$i18nUtil.trans("entity.paper.groupKbn.shar","HO!") : this.$i18nUtil.trans("entity.paper","보드");
          break;
        case "FILE":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.file","파일");
          break;
        case "IMAGE":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.image","이미지");
          break;
        case "REL_PAPER":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.relatedBoard","관련보드");
          break;
        case "LINK":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.url","URL");
          break;
        case "MENTION":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.mention","호출");
          break;
        case "OUTPUT":
          workKbnName = this.$i18nUtil.trans("entity.file.output","최종결과물");
          break;
        case "MEMBER":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.member","멤버");
          break;
        case "DECI":
          workKbnName = this.$i18nUtil.trans("entity.decision","의사결정");
          break;
        case "TABLE":
          workKbnName = this.$i18nUtil.trans("entity.paper.workItem.table","표");
          break;
        default:
          break;
      }
      return workKbnName;
    },
    getWorkItemName(workItemCode, workKbnCode) {
      let workItemName = "";
      switch (workItemCode) {
        case "ADD":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.add","추가");
          break;
        case "MOD":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.mod","수정");
          break;
        case "DELETE":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.delete","삭제");
          break;
        case "JOIN":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.join","참여");
          break;
        case "LEAVE":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.leave","제외");
          break;
        case "CREATED":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.created","최초생성");
          break;
        case "REGIST":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.regist","등록");
          break;
        case "REQUEST":
          workItemName = this.$i18nUtil.trans("entity.todo.filter.request","요청");
          break;
        case "COMPLETE":
          workItemName = workKbnCode == "TODO" ? this.$i18nUtil.trans("entity.todo.status.completed","완료") : this.$i18nUtil.trans("entity.decision.status.approval","승인");
          break;
        case "REJECTED":
          workItemName = this.$i18nUtil.trans("entity.decision.status.reject","반려");
          break;
        case "WAIT":
          workItemName = this.$i18nUtil.trans("entity.decision.status.proceeding","승인 전");
          break;
        case "UPDATED":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.update","업데이트");
          break;
        case "PAPER_COPY":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.paperCopy","보드 복제");
          break;
        case "PAPER_POST":
          workItemName = this.$i18nUtil.trans("entity.paper.workItem.status.papaerPost","보드 게시");
          break;
        default:
          break;
      }
      return workItemName;
    },
    getHistoryContent(historyItem) {
      let obj = this;
      let rtnHisotryContent = null;
      let strSeparator = " -> ";
      let wKbn = historyItem.workKbn;
      let wItem = historyItem.workItem;
      if (wKbn == "PAPER") {
        rtnHisotryContent = historyItem.attr1;
        if (wItem == "PAPER_COPY" || wItem == "PAPER_POST") {
          if (
            historyItem.groupKbn == "CFRC" ||
            historyItem.groupKbn == "SHAR"
          ) {
            rtnHisotryContent =
              historyItem.groupKbn == "SHAR" ? obj.$i18nUtil.trans("entity.cogroup.groupKbn.shar","정보공유") : obj.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의");
            rtnHisotryContent += " > " + historyItem.categoryName;
          } else {
            rtnHisotryContent =
              historyItem.groupKbn == "USER"
                ? obj.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗")
                : historyItem.groupName;
            rtnHisotryContent += " > " + historyItem.categoryName;
          }
        }
      } else if (wKbn == "TITLE") {
        rtnHisotryContent =
          obj.$i18nUtil.trans("message.BoardHistory.015", "제목변경") + "(" +
          historyItem.attr1 +
          strSeparator +
          historyItem.attr2 +
          ")";
      } else if (wKbn == "PERIOD") {
        // attr1: 변경전 시작일
        // attr2: 변경후 시작일
        // attr3: 변경전 종료일
        // attr4: 변경후 종료일
        rtnHisotryContent =
          obj.$i18nUtil.trans("message.BoardHistory.016", "기간변경") + "(" +
          obj.getDataFormatDateStr(historyItem.attr1, historyItem.attr2) +
          strSeparator +
          obj.getDataFormatDateStr(historyItem.attr3, historyItem.attr4) +
          ")";
      } else if (wKbn == "TODO") {
        rtnHisotryContent = historyItem.attr5;
      } else if (wKbn == "MEMBER") {
        rtnHisotryContent = historyItem.attr3;
      } else if (wKbn == "FILE") {
        rtnHisotryContent = historyItem.attr1;
      } else if (wKbn == "IMAGE") {
        rtnHisotryContent = historyItem.attr1;
      } else if (wKbn == "REL_PAPER") {
        if (historyItem.groupKbn == "SHAR" || historyItem.groupKbn == "CFRC") {
          rtnHisotryContent =
            historyItem.groupKbn == "SHAR" ? obj.$i18nUtil.trans("entity.cogroup.groupKbn.shar","정보공유") : obj.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의");;
          rtnHisotryContent +=
            " > " + historyItem.categoryName + " > " + historyItem.paperTitle;
        } else {
          rtnHisotryContent =
            (historyItem.groupKbn == "USER"
              ? obj.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗")
              : historyItem.groupName) +
            " > " +
            historyItem.paperTitle;
        }
      } else if (wKbn == "LINK") {
        rtnHisotryContent = historyItem.attr1;
      } else if (wKbn == "MENTION") {
        let rtnArrStr = "";
        if (historyItem.attr1.indexOf(",") != -1) {
          let arr = historyItem.attr1.split(",");
          arr.forEach((_arr) => {
            rtnArrStr += " @" + _arr.trim() + ", ";
          });
          rtnArrStr = rtnArrStr.replace(/\,\ {1}$/, " ");
        } else {
          rtnArrStr = " @" + historyItem.attr1 + " ";
        }
        rtnHisotryContent =
          rtnArrStr + obj.$i18nUtil.trans("message.BoardHistory.012","{loc}에서 호출됨", {loc: historyItem.attr2 == "OPINION"
            ? obj.$i18nUtil.trans("entity.opinoin.opinoin","의견")
              : historyItem.attr2 == "COMMENT"
            ? obj.$i18nUtil.trans("entity.opinoin.answer","답변")
             : obj.$i18nUtil.trans("entity.paper.mainText","본문")});
      } else if (wKbn == "OUTPUT") {
        rtnHisotryContent = historyItem.attr1;
      } else if (wKbn == "DECI") {
        rtnHisotryContent = historyItem.attr1;
      } else if (wKbn == "TABLE") {
        rtnHisotryContent = wItem == "ADD" ? obj.$i18nUtil.trans("message.BoardHistory.013","표 추가됨") : obj.$i18nUtil.trans("message.BoardHistory.014","표 삭제됨");
      }

      if (historyItem.workItem == "DELETE") {
        historyItem.classState = "del";
      }

      return rtnHisotryContent;
    },
    getDataFormatDateStr(_startDate, _endDate) {
      let rtnFormatDateStr = "";
      let dateSeparaotrStr = ".";
      if (
        _startDate != null &&
        _startDate != undefined &&
        _startDate.length != 0
      ) {
        rtnFormatDateStr =
          _startDate.substring(0, 4) +
          dateSeparaotrStr +
          _startDate.substring(4, 6) +
          dateSeparaotrStr +
          _startDate.substring(6, 8);
      }
      if (_endDate != null && _endDate != undefined && _endDate.length != 0) {
        rtnFormatDateStr +=
          "~" +
          _endDate.substring(0, 4) +
          dateSeparaotrStr +
          _endDate.substring(4, 6) +
          dateSeparaotrStr +
          _endDate.substring(6, 8);
      }
      return rtnFormatDateStr;
    },
    resizeBoardBlockTable(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      let table = div.querySelector("table");
      if (table) {
        let cols = table.querySelectorAll("[data-colwidth]");
        for (let col of cols) {
          let width = col.getAttribute("data-colwidth");
          col.style.width = width + "px";
        }
        this.boardUtil.fillNBSP(table);
      }
      return div.innerHTML;
    },
    loadImage(img, fileId) {
      let self = this;
      let paperInfo = this.$props.modalInfo.paperInfo;
      let fncLoadImage = function () {
        if (paperInfo.groupId) {
          let imageURI =
            "/api/cofile/paper/imageViewer?groupId=" +
            paperInfo.groupId +
            "&paperId=" +
            paperInfo.paperId +
            "&fileId=" +
            fileId;
          let xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
              img.src = URL.createObjectURL(xhr.response);
            }
          };
          xhr.open("GET", imageURI, true);
          var token = localStorage.getItem("Authorization");
          xhr.setRequestHeader("Authorization", token);
          xhr.responseType = "blob";
          xhr.send();
        } else {
          setTimeout(fncLoadImage, 500);
        }
      };
      setTimeout(fncLoadImage, 1);
    },
    toggleImage(target, ind, toggleValue) {
      if (
        this.paperBlockHistoryListFilter &&
        this.paperBlockHistoryListFilter.length > 0
      ) {
        this.paperBlockHistoryListFilter.forEach((elem) => {
          if (elem.paperBlockId == target.paperBlockId) {
            elem.toggleImage = toggleValue;
          }
        });
        this.showFlag = false;
        this.showFlag = true;
      }
    },
    changeBoardHistoryTab(index) {
      if (this.currentTab1 != index) {
        this.currentTab1 = index;
        if (index == 0) {
          this.getPaperBlockHistoryList();
        } else {
          this.dayPage = 0;
          this.dayTotalElements = 0;
          this.dayPaperHistoryList = [];
          this.dayPaperHistoryListFilter = [];
          this.getDayPaperHistoryList();
        }
      }
    },
    removeTag(html) {
      html = html == null ? "" : html;
      html = html.replace(/<(\/p|p|h|\/h)([^>]*)>/gi, "");
      return html;
    },
    changeDate(targetId) {
      if (targetId == "searchStartDay") {
        if (this.searchStartDay != "" && this.searchEndDay == "") {
          this.searchEndDay = this.searchStartDay;
        }
        if (this.searchStartDay > this.searchEndDay) {
          this.searchEndDay = this.searchStartDay;
        }
      } else {
        if (this.searchEndDay != "" && this.searchStartDay == "") {
          this.searchStartDay = this.searchEndDay;
        }
        if (this.searchStartDay > this.searchEndDay) {
          this.searchStartDay = this.searchEndDay;
        }
      }
      this.dayChangeTableData = true;
    },
    closeHistoryModal() {
      let hwWrapDiv = this.$root.$el.querySelector("div.hw_wrap");
      if (hwWrapDiv && hwWrapDiv != null) {
        if (hwWrapDiv.classList.contains("overflowhidden")) {
          hwWrapDiv.classList.remove("overflowhidden");
        }
      }
      this.$emit("close");
    },
    /* 한화 URL 체크 */
    modalTestHanwha(url) {
      let ptnPrefix = "^http[s]{0,1}://([a-zA-Z0-9]+[.]){0,1}(";
      let ptnSuffix = ")([/].*){0,1}$";
      for (let inx in HANWHA_DOMAINS) {
        let domain = HANWHA_DOMAINS[inx];
        let ptn = new RegExp(ptnPrefix + domain + ptnSuffix);
        let mat = ptn.exec(url);
        if (mat) {
          return mat;
        }
      }
      return false;
    },
    iconType(blockData) {
      let fileName = blockData.contentPath;
      let type = this.boardUtil.fileExt(fileName);
      let ext = "img";
      if (type[0] && type[0].length >= 3) {
        ext = type[0].substring(0, 3);
        if (type[0] === "tiff") {
          ext = type[0];
        } else if (
          ext === "jpg" ||
          ext === "gif" ||
          ext === "png" ||
          ext === "tif" ||
          ext === "bmp"
        ) {
          // NO-OP
        } else {
          ext = "img";
        }
      }
      return ext;
    },
    historyMultiElipsis(ellipsisLine) {
      if (this.ellipsisTimer) {
        clearTimeout(this.ellipsisTimer);
      }

      this.ellipsisTimer = setTimeout(function () {
        if ($(".multi-ellipsis").length > 0) {
          var omle = $(".multi-ellipsis");
          var $txtR = $("<div class='txtEllipsis'></div>");
          var $body = $("body");
          omle.each(function (idx) {
            var _this = $(this);
            var orinalWidth = $(this).width();
            var txtOmle = _this.text();

            $txtR.text(txtOmle);
            $body.append($txtR);

            if ($txtR.width() >= orinalWidth * 1.2) {
              _this.addClass("no-ellipsis");
            } else {
              _this.removeClass("no-ellipsis");
            }
          });
        }
      }, 250);

      setTimeout(function () {
        $(".txtEllipsis").remove();
      }, 1000);
    },
    getDecisionTargetEnName(objId) {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/getDecisionTargetEnName";
      reqData.method = "post";
      reqData.params = {
        id: objId,
      };
      return obj.COWORK_REST_SIMPLE_ACTION(reqData).then((res) => {
        if (res.errorCode) {
          console.log(res.errorCode);
        }else {
          let result = null;
          if(res.result && res.result.USER_NAME_EN) {
            result = res.result.USER_NAME_EN
          }
          return Promise.resolve(result); 
        }
        
      });
    },
    getTodo(todoId) {
      let obj = this;
      let reqData = {};
        reqData.url = "/api/copaper/todo/getTodo";
        reqData.method = "post";
        reqData.params = {
          todoId: todoId,
        };
      return obj.COWORK_REST_SIMPLE_ACTION(reqData).then((res) => {
        if (res.errorCode) {
          console.log(res.errorCode);
        }else {
          let result = null;
          if(res.result.todoT && res.result.todoT[0].chargerNameEn) {
            result = res.result.todoT[0].chargerNameEn
          }
          return result;
        }
      });
    }
  },
  mounted() {
    this.historyMultiElipsis(2);
    this.getPaperBlockHistoryList(true);
  },
  watch: {
    searchStartDay() {
      if(this.isDayInitFlag) {
        this.dayPage = 0;
        this.changeDate("searchStartDay");
      }
    },
    searchEndDay() {
      if(this.isDayInitFlag) {
        this.dayPage = 0;
        this.changeDate("searchEndDay");
      }
    },
    // dayPage: {
    //   handler() {
    //     if(this.dayChangeTableData != true) {
    //       this.dayChangeTableData = true;
    //     }
    //   }
    // },
    daySortBy: {
      handler() {
        this.dayPage = 0;
        // this.dayPaperHistoryList = [];
        // this.dayPaperHistoryListFilter = [];
        if(this.dayChangeTableData != true) {
          this.dayChangeTableData = true;
        }
      }
    },
    daySortDesc: {
      handler() {
        this.dayPage = 0;
        // this.dayPaperHistoryList = [];
        // this.dayPaperHistoryListFilter = [];
        if(this.dayChangeTableData != true) {
          this.dayChangeTableData = true;
        }
      }
    },
    dayChangeTableData: {
      handler() {
        let obj = this;
        if(obj.dayChangeTableData == true){
          setTimeout(()=>{
            obj.dayChangeTableData = false; 
            obj.getDayPaperHistoryList();
          }, 500);
        }
      },
      deep: true
    }
  },
};
</script>
<style scoped>
/* .editor-wrapper {
  width: 
} */
.editor-wrapper table tbody::before,
.editor-wrapper table tbody::after {
  display: none !important;
}
.editor-wrapper table tbody tr:hover::before,
.editor-wrapper table tbody tr:hover::after {
  display: none !important;
}
.img_box {
  clear: both;
  margin-top: 0;
}

.img_box > .one {
  position: relative;
  width: 100%;
  height: 400px;
  /* background: #eee; */
  text-align: center;
}
.img_box > .one > img.preview {
  position: absolute;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 400px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
}
.one .v-progress-circular {
  margin: 150px 0 0 0;
}
/* .img_box > .one:hover {
  opacity: 0.5;
} */

/* .board_layout .eidtbox-ty1.todo_wrap_view {
  margin-top: 0;
} */
.modal_todo_wrap {
  height: 66px !important;
  resize: none !important;
  padding: 12px 13px !important;
  border: 1px solid #acacac !important;
  font-size: 14px !important;
  color: #000 !important;
  width: 100% !important;
  padding-left: 13px !important;
  border-color: #acacac !important;
  background-color: transparent !important;
}

/* .txt.ell-singleline {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 800px;
} */
.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  min-height: 23px;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #f6f7fa !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}

[class*="todo_wrap"] .enCssDecision {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/history/BoardHistory.vue